import { schema } from "normalizr";

export const assetEquipmentsSchema = new schema.Entity("collection", {}, { idAttribute: type => type.id });
